import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  claim: null,
  getClaimStatus: IDLE,

  claimHistory: null,
  getClaimHistoryStatus: IDLE,

  createClaimStatus: IDLE,

  claimOrganizationsWithAccess: null,
  getClaimOrganizationsWithAccessStatus: IDLE,

  getClaimPdfSummaryStatus: IDLE,

  pdfClaimSummaryAndUploadToMessageStatus: IDLE,

  updateClaimStatusStatus: IDLE, // update ONLY the status field of the claim,

  fetchLatestClaimDataAndUpdateItStatus: IDLE,

  claimRecommendedSettlementPayeeData: null,
  claimRecommendedSettlementPayeeDataStatus: IDLE,

  showClaimEditOverviewModal: false
};

const claimSlice = createSlice({
  name: 'claim',
  initialState,
  reducers: {
    getClaim(state) {
      state.getClaimStatus = LOADING;
    },
    getClaimSucceeded(state, action) {
      state.claim = action.payload;
      state.getClaimStatus = SUCCEEDED;
    },
    getClaimFailed(state) {
      state.getClaimStatus = FAILED;
    },

    getClaimHistory(state) {
      state.getClaimHistoryStatus = LOADING;
    },
    getClaimHistorySucceeded(state, action) {
      state.claimHistory = action.payload;
      state.getClaimHistoryStatus = SUCCEEDED;
    },
    getClaimHistoryFailed(state) {
      state.getClaimHistoryStatus = FAILED;
    },

    getClaimPdfSummary(state) {
      state.getClaimPdfSummaryStatus = LOADING;
    },
    getClaimPdfSummarySucceeded(state) {
      state.getClaimPdfSummaryStatus = SUCCEEDED;
    },
    getClaimPdfSummaryFailed(state) {
      state.getClaimPdfSummaryStatus = FAILED;
    },

    getClaimPDFSummaryAndUploadToMessage(state) {
      state.pdfClaimSummaryAndUploadToMessageStatus = LOADING;
    },
    getClaimPDFSummaryAndUploadToMessageSucceeded(state) {
      state.pdfClaimSummaryAndUploadToMessageStatus = SUCCEEDED;
    },
    getClaimPDFSummaryAndUploadToMessageFailed(state) {
      state.pdfClaimSummaryAndUploadToMessageStatus = FAILED;
    },

    getClaimOrganizationsWithAccess(state) {
      state.getClaimOrganizationsWithAccessStatus = LOADING;
    },
    getClaimOrganizationsWithAccessSucceeded(state, action) {
      state.claimOrganizationsWithAccess = action.payload;
      state.getClaimOrganizationsWithAccessStatus = SUCCEEDED;
    },
    getClaimOrganizationsWithAccessFailed(state) {
      state.getClaimOrganizationsWithAccessStatus = FAILED;
    },

    createClaim(state) {
      state.createClaimStatus = LOADING;
    },
    createClaimSucceeded(state, action) {
      state.claim = action.payload;
      state.createClaimStatus = SUCCEEDED;
    },
    createClaimFailed(state) {
      state.createClaimStatus = FAILED;
    },

    setShowClaimEditOverviewModal(state, action) {
      state.showClaimEditOverviewModal = action.payload;
    },

    updateClaimStatus(state) {
      state.updateClaimStatusStatus = LOADING;
    },
    updateClaimStatusSucceeded(state, action) {
      state.updateClaimStatusStatus = SUCCEEDED;
      state.claim = action.payload;
    },
    updateClaimStatusFailed(state) {
      state.updateClaimStatusStatus = FAILED;
    },

    fetchLatestClaimDataAndUpdateIt(state) {
      state.fetchLatestClaimDataAndUpdateItStatus = LOADING;
    },
    fetchLatestClaimDataAndUpdateItSucceeded(state, action) {
      state.claim = action.payload;
      state.fetchLatestClaimDataAndUpdateItStatus = SUCCEEDED;
    },
    fetchLatestClaimDataAndUpdateItFailed(state) {
      state.fetchLatestClaimDataAndUpdateItStatus = FAILED;
    },

    getClaimRecommendedSettlementPayeeData(state) {
      state.claimRecommendedSettlementPayeeDataStatus = LOADING;
    },
    getClaimRecommendedSettlementPayeeDataSucceeded(state, action) {
      state.claimRecommendedSettlementPayeeData = action.payload;
      state.claimRecommendedSettlementPayeeDataStatus = SUCCEEDED;
    },
    getClaimRecommendedSettlementPayeeDataFailed(state) {
      state.claimRecommendedSettlementPayeeDataStatus = FAILED;
    },

    uploadFileAndUpdateClaim() {
      // No state changes needed, this is just for saga to listen to
    },

    clearClaim(state) {
      state.claim = null;
      state.getClaimStatus = IDLE;
    },
    clearClaimHistory(state) {
      state.claimHistory = null;
      state.getClaimHistoryStatus = IDLE;
    },
    clearClaimOrganizationsWithAccess(state) {
      state.claimOrganizationsWithAccess = null;
      state.getClaimOrganizationsWithAccessStatus = IDLE;
    }
  }
});

export const {
  getClaim,
  getClaimSucceeded,
  getClaimFailed,
  getClaimHistory,
  getClaimHistorySucceeded,
  getClaimHistoryFailed,
  getClaimPdfSummary,
  getClaimPdfSummarySucceeded,
  getClaimPdfSummaryFailed,
  getClaimPDFSummaryAndUploadToMessage,
  getClaimPDFSummaryAndUploadToMessageSucceeded,
  getClaimPDFSummaryAndUploadToMessageFailed,
  getClaimOrganizationsWithAccess,
  getClaimOrganizationsWithAccessSucceeded,
  getClaimOrganizationsWithAccessFailed,
  createClaim,
  createClaimSucceeded,
  createClaimFailed,
  getClaimRecommendedSettlementPayeeData,
  getClaimRecommendedSettlementPayeeDataSucceeded,
  getClaimRecommendedSettlementPayeeDataFailed,
  setShowClaimEditOverviewModal,
  updateClaimStatus,
  updateClaimStatusSucceeded,
  updateClaimStatusFailed,
  fetchLatestClaimDataAndUpdateIt,
  fetchLatestClaimDataAndUpdateItSucceeded,
  fetchLatestClaimDataAndUpdateItFailed,
  uploadFileAndUpdateClaim,
  clearClaim,
  clearClaimHistory,
  clearClaimOrganizationsWithAccess
} = claimSlice.actions;

export default claimSlice.reducer;
